module.exports = __webpack_public_path__ + "static/21-f9072bdff6cc9b360f8fddca6219e11d.jpg";